import { render, staticRenderFns } from "./GridLists.vue?vue&type=template&id=6b45057b"
import script from "./GridLists.vue?vue&type=script&lang=js"
export * from "./GridLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports